import React from 'react';
import './Product-specs-page.scss';
import {
    ExpandOutlined,
    AppstoreOutlined,
    ThunderboltOutlined,
    WifiOutlined,
    DashboardOutlined,
    PoweroffOutlined,
} from '@ant-design/icons';

const specGroups = [
    {
        icon: <ExpandOutlined />,
        title: 'Dimensions',
        specs: [
            'Width: 35.7″',
            'Height: 79.65″',
            'Depth: 32.24″ (door closed) / 59.50″ (door open)',
            'Visual opening: 25.50″W × 48″H × 20.125″D',
        ],
    },
    {
        icon: <AppstoreOutlined />,
        title: 'Shelving',
        specs: [
            'Adjustable shelving for customized planograms per location',
            'IntellishelfTM units in 1X and 2X sizes',
            'Flexible layout combinations for optimal pack-out',
            'Shelves programmable with full RGB lighting range',
            '~2.5″ clearance between tray back and rear wall grid',
        ],
    },
    {
        icon: <ThunderboltOutlined />,
        title: 'Cooling',
        specs: [
            'Refrigerant: R290',
            'Charge: 3.17 oz. (90g)',
            'Cools to 34˚F',
        ],
    },
    {
        icon: <WifiOutlined />,
        title: 'Connectivity',
        specs: [
            'Standard U.S. cellular communication',
            'Point-to-point encryption',
        ],
    },
    {
        icon: <DashboardOutlined />,
        title: 'Weight',
        specs: [
            'Approximate weight: 850 lbs.',
        ],
    },
    {
        icon: <PoweroffOutlined />,
        title: 'Power',
        specs: [
            'Standard 3-prong 120V AC plug',
        ],
    },
];

function ProductSpecsPage() {
    return (
        <div className={'product-specs-page-wrapper'}>
            <div className={'page-header'}>
                <h2 className={'page-title'}>Product Specs</h2>
                <p className={'page-subtitle'}>Technical specifications for the VICKI smart retail unit</p>
            </div>

            <div className={'specs-grid'}>
                {specGroups.map((group) => (
                    <div key={group.title} className={'spec-card'}>
                        <div className={'spec-card-header'}>
                            <span className={'spec-icon'}>{group.icon}</span>
                            <h3 className={'spec-card-title'}>{group.title}</h3>
                        </div>
                        <ul className={'spec-list'}>
                            {group.specs.map((spec, i) => (
                                <li key={i}>{spec}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ProductSpecsPage;
